import requests from './httpService';
import { appendRoleQuery, appendPaginationQuery } from '../../../../utils/activityCatalogScope';

const ActivityTabelService = {
  getActivityTabelById(id) {
    return requests.get(`/activitytabel/${id}`);
  },
  getAllActivityTabel(id, role, body, pagination) {
    let url = appendRoleQuery(`/activitytabel/list/${id}`, role);
    url = appendPaginationQuery(url, pagination);
    if (body && Object.keys(body).length > 0) {
      return requests.post(url, body);
    }
    return requests.get(url);
  },
 findActivityTabelList(body){
    return requests.post(`/activitytabel/find`,body); 
  },
  getStudentActivity(id,status) {
    return requests.get(`/activity/list/${id}/${status}`);
  },
  getAllSuperActivity(id) {
    return requests.get(`/superactivity/list/${id}`);
  },
  creteActivityTabel(body){
    return requests.post('/activitytabel/add',body); 
  },
  deleteActivityTabel(body){
    return requests.delete(`/activitytabel/${body._id}`); 
  },

  // getAllSubActivityByActivityId(body) {
  //   return requests.post(`/subactivity/listbyactivityid`,body);
  // },



  getAllActivityTabeBySuperActivityId(body, pagination) {
    const url = appendPaginationQuery(`/activitytabel/listbysuperactivityid`, pagination);
    return requests.post(url, body);
  },

  getActivitiesWithExercises(body) {
    return requests.post(`/activitytabel/list-with-exercises`, body);
  },





  
//   getAllCoupon() {
//     return requests.get('/coupon');
//   },
getAllAddClass() {
  return requests.get('/addclass');
},
  upadeActivityTabel(body) {
    return requests.put(`/activitytabel/${body._id}`,body); 
  },
//   creteCoupon(body){
//     return requests.post('/coupon/add',body); 
//   },
//   deleteCoupon(body){
//     return requests.delete(`/coupon/${body._id}`); 
//   },
//   createVendorOrdersById(body){
//     return requests.post('/orders/getvendororders',body); 
//   },

//   getAllVendorList() {
//     return requests.get('/vendorlist');
//   },

};

export default ActivityTabelService;
